<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
// Vue
import { computed } from "vue"
import { useRoute } from "vue-router"
import { useI18n } from "vue-i18n"

// Store
import { useBuildingStore } from "@core/stores/building-v2.store"
import { storeToRefs } from "pinia"

// ================================
// STORE & REACTIVE DATA
// ================================
const buildingStore = useBuildingStore()
const { isFetchingBuilding } = storeToRefs(buildingStore)

const route = useRoute()

/** Identifiant bâtiment (route) pour la liste d’accès (sans dépendre du store). */
const getBuildingId = computed(
    () => (route.params._id_building as string | undefined) ?? ""
)

// ================================
// I18N
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Partage d'accès",
            message:
                "Vous pouvez donner l'accès à votre bâtiment en cochant un contact de la liste.",
        },
    },
})

// ================================
// COMPUTED
// ================================
/** Chargement du bâtiment courant (store). */
const getIsFetching = computed(() => {
    return isFetchingBuilding.value
})
</script>

<template>
    <div class="page page-building-partage">
        <HeaderPageBuilding
            :title="t('title')"
            icon="fa-solid fa-share"
            class-header="flex flex-col gap-4"
        >
            <p class="text-gray-600 text-sm">
                {{ t("message") }}
            </p>
        </HeaderPageBuilding>

        <!-- Zone de contenu principal -->
        <template v-if="!getIsFetching && getBuildingId">
            <AccessBuildingListUser
                class="w-full mx-auto"
                :building-id="getBuildingId"
            />
        </template>

        <!-- État de chargement -->
        <template v-else>
            <BaseSkeleton width="50rem" height="50rem" class="mx-auto" />
        </template>
    </div>
</template>
